/**
 * ParkingPayment API
 *
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PaymentMethodType } from './paymentMethodType';


export interface CreateTicketDto { 
    ticketId?: number | null;
    locationId?: number;
    locationRateId?: number;
    discountCodes?: Array<string> | null;
    totalAmount?: number;
    vehicleRegistrationNo: string;
    phoneNumber: string;
    state_Province: string;
    paymentMethodType?: PaymentMethodType;
    cardHolderName?: string | null;
    cardNumber?: string | null;
    cvn?: string | null;
    expiryMonth?: number | null;
    expiryYear?: number | null;
    gPayToken?: string | null;
    applePayToken?: string | null;
    emailAddress?: string | null;
}
export namespace CreateTicketDto {
}


